import React from "react";

import {
  EditOutlined as EditOutlinedIcon,
  MailOutline as MailOutlineIcon,
  PhoneOutlined as PhoneOutlinedIcon,
  HighlightOffOutlined as HighlightOffOutlinedIcon,
  PersonOutline as PersonOutlineIcon,
  PeopleAltOutlined as PeopleAltOutlinedIcon,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";

import { Contact } from "../../../../../../../../models/contact";
import PhoneInput from "../../../../../../../../components/Form/PhoneInput";
import useStyles from "./styles";

interface Props {
  contacts?: Contact[];
  onSelectDeleteContact?: (contact: Contact) => void;
  onSelectEditContact?: (contact: Contact) => void;
  permission?: {
    edit: boolean
  }
}

const ContactsList = (props: Props) => {
  const { contacts, onSelectDeleteContact, onSelectEditContact, permission } = props;

  const classes = useStyles();
  const { t: translate } = useTranslation();

  const onConfirmDeleteContact = (contact: Contact) => {
    if (onSelectDeleteContact) onSelectDeleteContact(contact);
  };

  const onEditContact = (contact: Contact) => {
    if (onSelectEditContact) onSelectEditContact(contact);
  };

  return (
    <table className={classes.contactsTable} data-cy="businessContactsListTable">
      <tbody className={classes.contactsContainer} data-cy="businessContactsList">
        {contacts &&
          contacts.map((contact, index: number) => (
            <tr key={contact.id} className={classes.contactsRow}>
              <td className={classes.contactsItem}>
                <div className={classes.column}>
                  <PersonOutlineIcon htmlColor={"#98A2B3"} fontSize="small" />
                  <span>
                    {contact.firstName} {contact.lastName}
                  </span>
                </div>
              </td>
              <td className={classes.contactsItem}>
                <div className={classes.column}>
                  <MailOutlineIcon htmlColor={"#98A2B3"} fontSize="small" />
                  <span>{contact.email}</span>
                </div>
              </td>
              <td className={`${classes.contactsItem} phoneColumn`}>
                <div className={classes.column}>
                  <PhoneOutlinedIcon htmlColor={"#98A2B3"} fontSize="small" />
                  <PhoneInput
                    className={classes.personalizedPhoneInput}
                    isLabelStyle
                    value={
                      contact?.mobilePhone?.length > 0 && contact?.mobilePhone.includes("+")
                        ? contact?.mobilePhone
                        : `+${contact?.mobilePhone}`
                    }
                    placeholder="61430111900"
                    disabled
                  />
                </div>
              </td>
              <td className={classes.contactsItem}>
                <div className={classes.column}>
                  <PeopleAltOutlinedIcon htmlColor={"#98A2B3"} fontSize="medium" />
                  <span>{contact.userId ? translate("isAnUser") : translate("isNotAnUser")}</span>
                </div>
              </td>
              <td className={classes.contactsItem}>
                {(permission && permission.edit) && <div className={classes.actionsColumn}>
                  <EditOutlinedIcon
                    data-cy={`edit-${index}`}
                    className={classes.pointer}
                    htmlColor={"#98A2B3"}
                    fontSize="small"
                    onClick={() => onEditContact(contact)}
                  />

                  <HighlightOffOutlinedIcon
                    data-cy={`delete-${index}`}
                    className={classes.pointer}
                    htmlColor={"#F97066"}
                    fontSize="small"
                    onClick={() => onConfirmDeleteContact(contact)}
                  />
                </div>}
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  );
};

export default ContactsList;
